import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Flex, Box } from 'rebass'

import { media } from '../../../utils/style'

const ModalOuter = styled(({ slim, ...rest }) => <Flex {...rest} />)`
  z-index: 1000;
  position: fixed;
  width: 100%;
  ${media.LargeScreenUp`
  max-width: ${(props) => (props.slim ? '43%' : '85%')};
  min-width: 10%;
  `};
  max-height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const ModalInner = styled(Flex)`
  overflow: auto;
  width: 100%;
  max-height: 100%;
  background-color: white;
  font-size: ${rem(15)};
  color: ${(props) => props.theme.colors.grey_op80};

  .focused ~ .summary {
    display: none;
  }
`

const Header = styled(Box)`
  position: relative;
  text-align: center;
  order: -1;
  background-color: ${(props) => props.theme.colors.blue};
  color: ${(props) => props.theme.colors.white};
  a {
    color: ${(props) => props.theme.colors.white};
    text-decoration: none;
  }
`

const Summary = styled(Box)`
  position: relative;
  line-height: 1.6;
  order: -1;
  background-color: ${(props) => props.theme.colors.white};
`

const Shadow = styled(Box)`
  ${media.LargeScreenUp`
  &::after {
    content:'';
    position: absolute;
    bottom: 2%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    box-shadow: 0 20px 40px 0px rgba(66,76,94,0.2),
                0 15px 35px 0 rgba(0,0,0,0.15);
    z-index: -1;
    pointer-events: none;
  }
  `};
`

const Close = styled.a`
  cursor: pointer;
  position: absolute;
  top: 50px;
  right: 1.8%;
  transform: translateY(-90%);
  path {
    transition: opacity 0.5s cubic-bezier(0.19, 1, 0.22, 1);
    transform: scale(0.45);
    transform-origin: center;
    fill: white;
    opacity: 0.5;
  }
  &:hover path {
    opacity: 1;
  }
`

Close.displayName = 'Close'

const ModalDimmer = styled.div`
  background: #424a5e;
  height: 100vh;
  width: 100%;
  position: fixed;
  z-index: 100;
  transform: translate3d(0, 0, 0.00002);
  opacity: 0.7;
  transition: opacity 0.5s ${(props) => props.theme.ease.ease_out_expo};
  top: 0;
  left: 0;
  &.hide {
    opacity: 0 !important;
    pointer-events: none;
  }
`

const ModalAction = styled(Flex)`
  text-align: center;
  padding: 0 30px 30px;
  width: 100%;
  justify-content: center;
`

export {
  ModalOuter,
  ModalInner,
  Header,
  Summary,
  ModalDimmer,
  ModalAction,
  Close,
  Shadow
}
